export const getSocialImageUrl = ({
  baseUrl,
  shape = 'square',
  color = 'color',
  network = 'facebook',
}) => `${baseUrl}/images/social-icons/${shape}/${color}/${network}.png`;
